import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class ClientsWoESolutionCfg {
  public detailEndpointPattern: string;
}

export class ClientsWoBulletinsCfg {
  public detailEndpointPattern: string;
}

export class AdministrativeManagementDigitalizationKpiCfg {
  public clientsWoESolution: ClientsWoESolutionCfg;
  public clientsWoBulletins: ClientsWoBulletinsCfg;
}

@Injectable()
export class AdministrativeManagementDigitalizationKpiCfgService extends CfgService<AdministrativeManagementDigitalizationKpiCfg> {
  json: any = {
    clientsWoESolution: {
      detailEndpointPattern: "%{DashboardApiUrl}/digitalization/{0}/noebusinessclients/detail"
    },
    clientsWoBulletins: {
      detailEndpointPattern: "%{DashboardApiUrl}/digitalization/{0}/nobulletinsclients/detail"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/administrativeManagementDigitalizationKpi.cfg.json`;
  }

   /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
